import jwt from "jwt-decode";

const SESSION_STORAGE = {
	USER_ID: 'userId',
	TOKEN: 'token',
	USER_NAME: 'userName',
	REPORTS_USER_ID: 'reportsUserId',
	REPORTS_TOKEN: 'reportsToken',
	USER_ROLES: 'userRoles',
	USER_LIST: 'userList',
	APIKEY: 'apiKey',
	USERTZ: 'userTZ',
	IS_SUPER_ADMIN: 'isSuperAdmin',
	USER_EMAIL: 'userEmail',
	SLASHCALL_SUPER_ADMIN_EMAIL: 'slashcallSuperAdminEmail',
	SLASHCALL_SUPER_ADMIN_PERSONA_API_KEY: 'slashcallSuperAdminPersonaApiKey'
};
export const isLoggedIn = () => {
	return !!localStorage.getItem(SESSION_STORAGE.USER_ID);
};

const isJwtTokenExpired = () => {
	let isExpired = false;
	let decodedToken: any;
	const token = getAuthToken();
	try {
		if (token !== null && token !== '') {
			decodedToken = jwt(token);
			const dateNow = new Date();
			if (decodedToken.exp * 1000 < dateNow.getTime()) {
				isExpired = true;
			} else {
				isExpired = false;
			}
			return isExpired;
		} else {
			return false;
		}
	} catch (err) {
		return false;
	}
};

export const getUserId = () => {
	let userId = localStorage.getItem(SESSION_STORAGE.USER_ID);
	if(userId!==null && userId!==undefined && userId!==''){
		return userId
	}

	if(!isJwtTokenExpired()){	
		console.log("UserID is missing, re checking and adding again..")
		let token:any = localStorage.getItem('mfaToken');
		if (!token) return '';
		 const { userId: decodedUserId }: any = jwt(token)
	 	 if (decodedUserId) {
      		localStorage.setItem(SESSION_STORAGE.USER_ID, decodedUserId);
     		 return decodedUserId;
    	}
	}
	return '';
};

export const isSuperAdmin = () => {
	return localStorage.getItem(SESSION_STORAGE.IS_SUPER_ADMIN);
};

export const isSubAdmin = () => {
	try {
		if (getParsedParentUserId()) {
			return true;
		} else {
			return false;
		}
	} catch (error) {
		console.log(error);
		return false;
	}
};

export const getParsedParentUserId = (): string | null => {
	try {
		return JSON.parse(localStorage.getItem("parentUser") || '{}')?.id?.toString() || null;
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const getParsedParentUserName = (): string | null => {
	try {
		return JSON.parse(localStorage.getItem("parentUser") || '{}')?.username || null;
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const getParentUserId = () => {
	return localStorage.getItem("parentUser");
};

export const setUserData = (userDetails: any) => {
	localStorage.setItem(SESSION_STORAGE.USER_ID, userDetails.UserId);
	localStorage.setItem(SESSION_STORAGE.TOKEN, userDetails.token);
	localStorage.setItem(SESSION_STORAGE.USER_NAME, userDetails.name);
	// localStorage.setItem(SESSION_STORAGE.USER_ROLES, userDetails.roles);
	localStorage.setItem(SESSION_STORAGE.APIKEY, userDetails.apiKey);
	localStorage.setItem(SESSION_STORAGE.USERTZ, userDetails.userTZ);
	setUserEmail(userDetails.email);
};

export const setRoleData = (userDetails: any) => {
	localStorage.setItem(SESSION_STORAGE.USER_ROLES, userDetails.roles);
};

export const setUserDataWithUserList = (userDetails: any) => {
	localStorage.setItem(SESSION_STORAGE.USER_ID, userDetails.UserId);
	localStorage.setItem(SESSION_STORAGE.TOKEN, userDetails.token);
	localStorage.setItem(SESSION_STORAGE.USER_NAME, userDetails.name);
	// localStorage.setItem(SESSION_STORAGE.USER_ROLES, userDetails.roles);
	localStorage.setItem(SESSION_STORAGE.USER_LIST, userDetails.userList);
	localStorage.setItem(SESSION_STORAGE.APIKEY, userDetails.apiKey);
	localStorage.setItem(SESSION_STORAGE.USERTZ, userDetails.userTZ);
	setUserEmail(userDetails.email);
};

export const getUserEmail = (): string | null => {
	return localStorage.getItem(SESSION_STORAGE.USER_EMAIL);
};

export const setUserEmail = (email?: string | null) => {
	const normalizedEmail = email?.trim();
	if (normalizedEmail) {
		localStorage.setItem(SESSION_STORAGE.USER_EMAIL, normalizedEmail);
		return;
	}
};

export const clearUserEmail = () => {
	localStorage.removeItem(SESSION_STORAGE.USER_EMAIL);
};

export const getAuthToken = () => {
	return localStorage.getItem(SESSION_STORAGE.TOKEN);
};

export const getUserName = (): string | null => {
	return localStorage.getItem(SESSION_STORAGE.USER_NAME);
};

export const clearSession = () => {
	sessionStorage.clear();
	const themeColor = localStorage.getItem('themeColor');
	localStorage.clear();
	if (themeColor) {
		localStorage.setItem('themeColor', themeColor);
	}
};

export const getUserRoles = () => {
	let roles: any = localStorage.getItem(SESSION_STORAGE.USER_ROLES)
	return JSON.parse(roles) || null
}

export const getisSuperAdminTrue = () => {
	let token: any = localStorage.getItem("token")
	return token || null
}

export const getUserList = () => {
	return localStorage.getItem(SESSION_STORAGE.USER_LIST);
}

export const getSelectedUserName = () => {
	let username = (localStorage.getItem("selectedUser") !== null && localStorage.getItem("selectedUser") !== undefined && localStorage.getItem("selectedUser") !== "null" && localStorage.getItem("selectedUser") !== "undefined") ? localStorage.getItem("selectedUser") : localStorage.getItem(SESSION_STORAGE.USER_NAME);
	return username || '';
}

const getJwtUserId = (): string => {
	try {
		const token = getAuthToken();
		if (!token) {
			return '';
		}
		const decoded: any = jwt(token);
		return (decoded?.user?.userId ?? decoded?.userId)?.toString() || '';
	} catch {
		return '';
	}
};

export const isSuperAdminLoggedIn = (): boolean => {
	if (isSuperAdmin() === 'true') {
		return true;
	}
	try {
		const token = getAuthToken();
		if (!token) {
			return false;
		}
		const decoded: any = jwt(token);
		return decoded?.isSupperAdmin === true || decoded?.user?.isSupperAdmin === true;
	} catch {
		return false;
	}
};

export const isAccountSwitched = (): boolean => {
	const jwtUserId = getJwtUserId();
	const currentUserId = getUserId()?.toString();
	if (!jwtUserId || !currentUserId) {
		return false;
	}
	return jwtUserId !== currentUserId;
};

export const canCacheSlashcallSuperAdminPersona = (hasSlashcallRole: boolean): boolean => {
	return hasSlashcallRole && isSuperAdminLoggedIn() && !isAccountSwitched();
};

export const getSlashcallSuperAdminEmail = (): string | null => {
	return localStorage.getItem(SESSION_STORAGE.SLASHCALL_SUPER_ADMIN_EMAIL);
};

export const setSlashcallSuperAdminEmail = (email: string) => {
	const normalizedEmail = email?.trim();
	if (normalizedEmail) {
		localStorage.setItem(SESSION_STORAGE.SLASHCALL_SUPER_ADMIN_EMAIL, normalizedEmail);
	}
};

export const getSlashcallSuperAdminPersonaApiKey = (): string | null => {
	return localStorage.getItem(SESSION_STORAGE.SLASHCALL_SUPER_ADMIN_PERSONA_API_KEY);
};

export const setSlashcallSuperAdminPersonaApiKey = (apiKey: string) => {
	const normalizedApiKey = apiKey?.trim();
	if (normalizedApiKey) {
		localStorage.setItem(SESSION_STORAGE.SLASHCALL_SUPER_ADMIN_PERSONA_API_KEY, normalizedApiKey);
	}
};

export const cacheSlashcallSuperAdminEmail = (email?: string | null, hasSlashcallRole = false) => {
	if (!canCacheSlashcallSuperAdminPersona(hasSlashcallRole)) {
		return;
	}
	const normalizedEmail = email?.trim();
	if (normalizedEmail) {
		setSlashcallSuperAdminEmail(normalizedEmail);
	}
};

export const cacheSlashcallSuperAdminPersonaApiKey = (apiKey?: string | null, hasSlashcallRole = false) => {
	if (!canCacheSlashcallSuperAdminPersona(hasSlashcallRole)) {
		return;
	}
	const normalizedApiKey = apiKey?.trim();
	if (normalizedApiKey) {
		setSlashcallSuperAdminPersonaApiKey(normalizedApiKey);
	}
};

export const preserveSlashcallSuperAdminPersonaBeforeSwitch = (hasSlashcallRole: boolean) => {
	if (!canCacheSlashcallSuperAdminPersona(hasSlashcallRole)) {
		return;
	}
	cacheSlashcallSuperAdminEmail(getUserEmail(), hasSlashcallRole);
	const cachedApiKey = getSlashcallSuperAdminPersonaApiKey();
	if (cachedApiKey) {
		return;
	}
};

export const resolveSlashcallPersonaEmail = (
	hasSlashcallRole: boolean,
	currentEmail?: string | null
): string => {
	const normalizedCurrentEmail = currentEmail?.trim() || '';
	if (!hasSlashcallRole || !isSuperAdminLoggedIn()) {
		return normalizedCurrentEmail;
	}
	if (!isAccountSwitched()) {
		cacheSlashcallSuperAdminEmail(normalizedCurrentEmail, hasSlashcallRole);
		return normalizedCurrentEmail;
	}
	return (getSlashcallSuperAdminEmail() || '').trim() || normalizedCurrentEmail;
};

export const resolveSlashcallPersonaApiKey = (
	hasSlashcallRole: boolean,
	currentApiKey?: string | null
): string => {
	const normalizedCurrentApiKey = currentApiKey?.trim() || '';
	if (!hasSlashcallRole || !isSuperAdminLoggedIn()) {
		return normalizedCurrentApiKey;
	}
	if (!isAccountSwitched()) {
		cacheSlashcallSuperAdminPersonaApiKey(normalizedCurrentApiKey, hasSlashcallRole);
		return normalizedCurrentApiKey;
	}
	return (getSlashcallSuperAdminPersonaApiKey() || '').trim() || normalizedCurrentApiKey;
};